import { handleActions } from 'redux-actions';
import { Actions, uploadThemeFailure } from 'actions/themeActions';
import { Actions as BuildingActions } from 'actions/buildingActions';
import { Actions as EditorActions } from 'actions/editorActions';
import { Theme, ThemeId } from 'shared/models';
import { keyBy, merge, omit } from 'lodash';

export type State = {
    data: Record<ThemeId, Theme>;
    uploading?: {
        progress: number;
        success: boolean;
        error: string | null;
    };
    schedule: {
        pending: boolean;
        error: string | null;
    };
};

// Helper method to add an array of themes into the given state
const addThemes = (state: State, themes: Theme[]): State => ({
    ...state,
    data: {
        ...omit(state.data, themes.map(t => t.id)),
        ...keyBy(themes, 'id'),
    },
});

export const initialState = Object.freeze<State>({
    data: {},
    schedule: {
        pending: false,
        error: null,
    },
});

export const themesReducer = handleActions({
    [Actions.DELETE_THEME_SUCCESS]: (state: State, action: any) => {
        const themeId = action.payload;
        return {
            ...state,
            data: omit(state.data, themeId),
        };
    },

    //[Actions.PUBLISH_THEME_REQUEST]: (state: State, action: any) => {
    //},
    [Actions.PUBLISH_THEME_SUCCESS]: (state: State, action: any) => {
        return addThemes(state, [ action.payload ]);
    },
    //[Actions.PUBLISH_THEME_FAILURE]: (state: State, action: any) => {
    //},

    //[Actions.UNPUBLISH_THEME_REQUEST]: (state: State, action: any) => {
    //},
    [Actions.UNPUBLISH_THEME_SUCCESS]: (state: State, action: any) => {
        return addThemes(state, [ action.payload ]);
    },
    //[Actions.UNPUBLISH_THEME_FAILURE]: (state: State, action: any) => {
    //},

    [Actions.COPY_THEME_TO_BUILDING_SUCCESS]: (state: State, action: any) => {
        return addThemes(state, [ action.payload ]);
    },

    //[Actions.RESET_THEME_STATUS_REQUEST]: (state: State, action: any) => {
    //},
    [Actions.RESET_THEME_STATUS_SUCCESS]: (state: State, action: any) => {
        return addThemes(state, [ action.payload ]);
    },
    //[Actions.RESET_THEME_STATUS_FAILURE]: (state: State, action: any) => {
    //},

    [Actions.UPLOAD_THEME_REQUEST]: (state: State, action: any) => {
        return merge({}, state, { uploading: {
            progress: 0,
        } });
    },
    [Actions.UPLOAD_THEME_PROGRESS]: (state: State, action: any) => {
        return merge({}, state, { uploading: { progress: action.payload } });
    },
    [Actions.UPLOAD_THEME_SUCCESS]: (state: State, action: any) => {
        return merge(addThemes(state, [ action.payload ]), {
            uploading: {
                progress: 1,
                success: true,
            },
        });
    },
    [Actions.UPLOAD_THEME_FAILURE]: (state: State, action: ReturnType<typeof uploadThemeFailure>) => {
        return merge({}, state, { uploading: {
            success: false,
            error: action.payload,
        } });
    },
    [Actions.CLEAR_UPLOAD_THEME]: (state: State, action: any) => {
        return omit(state, 'uploading');
    },


    //
    //  Building Actions
    //
    [BuildingActions.GET_BUILDING_THEMES_SUCCESS]: (state: State, action: any) => {
        const themes = action.payload;
        return addThemes(state, themes);
    },


    //
    //  Editor Actions
    //
    [EditorActions.SAVE_THEME_SUCCESS]: (state: State, action: any) => {
        const { theme } = action.payload;
        return addThemes(state, [ theme ]);
    },
} as any, initialState);
